var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveOnlyBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 49,
    viewBox: "0 0 500 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.815 37.9387C406.268 38.677 449.995 33.1375 500 15.1055L500 26.0912C448.138 44.793 408.412 49.7102 369.425 48.9206C330.615 48.1345 296.045 40.5699 261.178 32.6209C259.528 32.2447 257.876 31.8673 256.222 31.4893C188.154 15.94 115.985 -0.546448 -8.31918e-08 25.278C104.356 -19.1024 191.642 5.25779 260.366 20.9583C262.043 21.3414 263.716 21.7236 265.386 22.1042C300.33 30.0711 333.186 37.1968 369.815 37.9387Z",
    fill: "#0044C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveOnlyBig);
export default __webpack_public_path__ + "static/media/wave-only-big.003bba930e128d1558adf95198750d36.svg";
export { ForwardRef as ReactComponent };